import SettingsPage from '@/pages/admin/SettingsPage/SettingsPage.vue'

export default SettingsPage
